import { gql } from '@/__generated__/gql';

export const FIELD_CONFIGURATION_MODAL_PAGE_LIST_DUE_DILIGENCE_RECORD_QUERY = gql(`
  query FieldConfigurationModalPageListDueDiligenceRecords($data: DueDiligenceRecordsListDto!) {
    listDueDiligenceRecords(data: $data) {
      total
      limit
      offset
      records {
        id
        investment {
          id
          name
        }
        activeTier {
          id
          funnel {
            id
          }
        }
      }
    }
  }
`);

export const FIELD_CONFIGURATION_MODAL_PAGE_GET_DUE_DILIGENCE_RECORD_QUERY = gql(`
  query FieldConfigurationModalPageGetDueDiligenceRecord($id: String!) {
    getDueDiligenceRecord(id: $id) {
      id
      funnel {
        id
        tiers {
          id
          sections {
            id
            fields {
              id
              type
              data {
                id
                value
                commentary
              }
              AI {
                answers
                answerJson
              }
              promptGroup {
                id
              }
            }
          }
        }
      }
    }
  }
`);
